<template>
  <div>
    <v-select
      hide-details
      :items="targetingGeoLocationsTypes"
      item-text="name"
      item-value="key"
      outlined
      :value="value"
      @input="onInput"
    ></v-select>
  </div>
</template>

<script>
import { get } from "vuex-pathify"

export default {
  name: "GeoLocationType",
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    ...get("enumerations", ["targetingGeoLocationsTypes"]),
  },
  methods: {
    onInput(val) {
      this.$emit("input", val)
    },
  },
}
</script>

<style scoped></style>
